<div class="ws-popup-content">
  <div class="ws-popup-body">
    <div class="confirm-dialog">
      <div class="confirm-icon">
        <mat-icon>help_outline</mat-icon>
      </div>

      <div class="confirm-message">
        <h2 class="confirm-title" *ngIf="title">{{ title }}</h2>
        <p [innerHTML]="message"></p>
      </div>
    </div>
  </div>
  
  <div class="ws-popup-footer">
    <div *ngIf="buttons.yes.display && buttons.no.display" class="confirm-buttons">
      <ws-button (click)="noClicked()" [callToActionType]="'tertiary'">
        {{buttons.no.text}}
      </ws-button>
      <ws-button (click)="yesClicked()" [callToActionType]="$any(yesType)">
        {{buttons.yes.text}}
      </ws-button>
    </div>

    <div *ngIf="!buttons.yes.display || !buttons.no.display" class="confirm-buttons">
      <ws-button (click)="noClicked()" *ngIf="buttons.no.display" [callToActionType]="'tertiary'">
        {{buttons.no.text}}
      </ws-button>
      <ws-button (click)="yesClicked()" *ngIf="buttons.yes.display" [callToActionType]="$any(yesType)">
        {{buttons.yes.text}}
      </ws-button>
    </div>
  </div>
</div>